// extracted by mini-css-extract-plugin
export var actionButton = "_oh-0";
export var actionMenuContainer = "_oh-i";
export var bubble = "_oh-2";
export var bubbleActionMenu = "_oh-j";
export var bubbleContext = "_oh-6";
export var bubbleItems = "_oh-7";
export var customer = "_oh-3";
export var divider = "_oh-8";
export var fileList = "_oh-9";
export var hiddenComment = "_oh-o";
export var infoAbove = "_oh-a";
export var internal = "_oh-4";
export var lightActionButton = "_oh-1";
export var link = "_oh-b";
export var merchant = "_oh-5";
export var message = "_oh-c";
export var profilePicture = "_oh-e";
export var quillToolbarContainer = "_oh-f";
export var senderDate = "_oh-g";
export var senderDateCustomer = "_oh-h";
export var senderName = "_oh-d";
export var time = "_oh-k";
export var uploadedImage = "_oh-l";
export var username = "_oh-m";
export var xsmall = "_oh-n";